$(document).ready(function() {
	function close_accordion() {
		$('.accordion .accordion-header').removeClass('active');
		$('.accordion .accordion-content')
			.slideUp(300)
			.removeClass('show');
	}

	$('.accordion-header').click(function() {
		if ($(this).is('.active')) {
			close_accordion();
		} else {
			close_accordion();
			$(this).addClass('active');
			$('.active')
				.next()
				.slideDown(300)
				.addClass('show');
		}
	});
});

// Remove when switch is complete
$('.expander-trigger').click(function(e) {
	e.stopPropagation();
	$(this).toggleClass('expander-hidden');
});
